import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CloseIcon from "@mui/icons-material/Close";

const StatusDialog = ({ title, onClose, showProgress = false, message }) => {
  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth={false}
      sx={{ "& .MuiDialog-paper": { maxWidth: "440px", width: "100%" } }}
    >
      <DialogTitle>
        <Typography fontSize={20} fontWeight={500} color="text.primary" align="center">
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          size="large"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        {showProgress && <LinearProgress />}
        {message && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: showProgress ? 2 : 0 }}>
            {message}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default StatusDialog;
